import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";

// style lấy tạm bên metadataDetail, sẽ để độc lập sau
function WatchMoreText({ textInput, wordLength = 200 }) {
  const [showWatchMore, setShowWatchMore] = useState(false);

  const shouldShowMore = textInput.length > wordLength;

  const truncatedText = useMemo(() => {
    const lastSpaceIndex = textInput.slice(0, wordLength).lastIndexOf(" ");
    return lastSpaceIndex > 0
      ? textInput.slice(0, lastSpaceIndex)
      : textInput.slice(0, wordLength);
  }, [textInput, wordLength]);
  return (
    <div className="bioPlaylistCommentArea">
      <span className="bioPlaylistComment">
        {shouldShowMore
          ? showWatchMore
            ? textInput
            : truncatedText + "..."
          : textInput}
      </span>
      {shouldShowMore && (
        <button
          className="bioShowMore"
          onClick={() => setShowWatchMore(!showWatchMore)}
        >
          {!showWatchMore ? "Xem thêm" : "Thu gọn"}{" "}
          <FontAwesomeIcon
            icon={!showWatchMore ? faChevronDown : faChevronUp}
          />
        </button>
      )}
    </div>
  );
}

export default WatchMoreText;
